import { render, staticRenderFns } from "./send-list.vue?vue&type=template&id=352d3676&scoped=true"
import script from "./send-list.vue?vue&type=script&lang=js"
export * from "./send-list.vue?vue&type=script&lang=js"
import style0 from "./send-list.vue?vue&type=style&index=0&id=352d3676&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d3676",
  null
  
)

export default component.exports